import React from 'react'
import { Card, CardBody, Col } from 'reactstrap'
import CardHeaderSpan from '../../../../../Utils/CommonComponents/CardHeaderSpan'
import { TrendingPostsTitle } from '../../../../../Utils/Constants'
import { H5, H6, LI, P, UL } from '../../../../../AbstractElements'
import { trendingPostsData } from '../../../../../Data/MiscellaneousData/BlogData'

export default function TrendingPosts() {
    return (
        <Col sm={12}>
            <Card>
                <CardHeaderSpan headingClassName='pb-0 border-0' smallHeading={TrendingPostsTitle} />
                <CardBody>
                    <UL className="recent-blog trending-blog simple-list">
                        {trendingPostsData.map((item) => (
                            <LI key={item.id}>
                                <div className="d-flex gap-2 align-items-start">
                                    <H5>{item.id}.</H5>
                                    <div className="flex-grow-1">
                                        <H6>{item.title}</H6>
                                        <P>{item.date}</P>
                                    </div>
                                </div>
                            </LI>
                        ))}
                    </UL>
                </CardBody>
            </Card>
        </Col>
    )
}